import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import 'moment/locale/es';

import { AuthContext } from '../context/auth';
import { MerchantsContext } from '../context/merchants/MerchantContext';
import QuickAccess from "../components/ui/QuickAccess";

const getGreeting = () => {
    const hour = moment().hour();
    if (hour < 12) return 'Buenos días';
    if (hour < 19) return 'Buenas tardes';
    return 'Buenas noches';
};

export const WelcomenPage = () => {
    const { user } = useContext(AuthContext);
    const { getWithoutITBMSConfiguration } = useContext(MerchantsContext);
    const [pendingItbms, setPendingItbms] = useState(0);
    const alertShownRef = useRef(false);

    const navigate = useNavigate();

    // Backoffice: aviso de comercios con configuración de ITBMS pendiente
    useEffect(() => {
        if (user.groups[0].id == 3) {
            getWithoutITBMSConfiguration().then((merchants) => {
                if (merchants?.length > 0 && !alertShownRef.current) {
                    alertShownRef.current = true;
                    setPendingItbms(merchants.length);
                }
            }).catch(() => { });
        }
    }, []);

    const today = moment().locale('es').format('dddd, D [de] MMMM [de] YYYY');
    const groupName = user?.groups?.[0]?.name;
    const merchantName = user?.merchant?.name ?? user?.bank?.description;   // usuarios de banco: su banco

    return (
        <div className='mt-5 container-fluid px-4' style={styles.container}>

            {/* Encabezado */}
            <div className="card border-0 shadow-sm mb-4 overflow-hidden">
                <div className="card-body p-4" style={styles.hero}>
                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                        <div>
                            <div className="text-muted small text-capitalize mb-1">{today}</div>
                            <h3 className="mb-1">{getGreeting()}, {user?.name}</h3>
                            <p className="text-muted mb-0">Bienvenido al panel administrativo.</p>
                        </div>
                        {(merchantName || groupName) && (
                            <div className="d-flex flex-wrap gap-2">
                                {merchantName && (
                                    <span className="badge rounded-pill bg-white text-body border px-3 py-2">
                                        <i className="bi bi-shop me-1 text-primary" />{merchantName}
                                    </span>
                                )}
                                {groupName && (
                                    <span className="badge rounded-pill bg-primary-subtle text-primary-emphasis px-3 py-2">
                                        <i className="bi bi-person-badge me-1" />{groupName}
                                    </span>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Aviso ITBMS (solo backoffice) */}
            {pendingItbms > 0 && (
                <div className="alert alert-warning d-flex align-items-center justify-content-between flex-wrap gap-2 border-0 shadow-sm mb-4" role="alert">
                    <div>
                        <i className="bi bi-exclamation-triangle me-2" />
                        Hay {pendingItbms} comercio(s) con configuración de ITBMS pendiente.
                    </div>
                    <div className="d-flex gap-2">
                        <button type="button" className="btn btn-sm btn-warning" onClick={() => navigate('/merchants')}>
                            Ver comercios
                        </button>
                        <button type="button" className="btn-close" aria-label="Cerrar" onClick={() => setPendingItbms(0)} />
                    </div>
                </div>
            )}

            {/* Accesos rápidos */}
            <div data-tour="quick-access">
                <h6 className="text-muted text-uppercase small mb-3">Accesos rápidos</h6>
                <QuickAccess />
            </div>

            <div style={{ height: '60px' }}></div>
        </div>
    );
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
    },
    hero: {
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e7f1ff 100%)',
    },
};
